import React from 'react';
import { Box, Card, CardActionArea, CardContent, SxProps, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { changePopUpStates } from '../../system/Slicer/CommonSlicer';
import { DefaultSetting } from '../defaultSetting';

export interface FlexPhotoItem {
    src: string;
    alt?: string;
    caption?: React.ReactNode | string;
    height?: string | number;
    sx?: SxProps;
    imgSx?: SxProps;
    noHoverAni?: boolean;
    noImgPopup?: boolean;
    onClick?: () => void;
}

export type FlexPhotoInput = string | FlexPhotoItem;

export interface FlexPhotoRowProps {
    images: Array<FlexPhotoInput>;
    height?: string | number;
    justifyContent?: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
    alignItems?: 'center' | 'flex-start' | 'flex-end' | 'stretch';
    gap?: number | string;
    sx?: SxProps;
}

export function FlexPhotoRow(props: FlexPhotoRowProps) {
    const dispatch = useDispatch();

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: props.justifyContent ?? 'center',
                alignItems: props.alignItems ?? 'center',
                gap: props.gap ?? 2,
                my: 2,
                width: '100%',
                ...props.sx,
            }}
        >
            {props.images.map((item, index) => {
                const itemObj: FlexPhotoItem = typeof item === 'string' ? { src: item } : item;
                const rawHeight = itemObj.height ?? props.height ?? '450px';
                const formattedHeight = typeof rawHeight === 'number' ? `${rawHeight}px` : rawHeight;

                const handleClick = () => {
                    if (itemObj.onClick) {
                        itemObj.onClick();
                    } else if (!itemObj.noImgPopup && itemObj.src) {
                        dispatch(changePopUpStates({ src: itemObj.src }));
                    }
                };

                const hoverEffect = itemObj.noHoverAni ? {} : DefaultSetting.hoverZoomAni;

                return (
                    <Card
                        key={index}
                        sx={{
                            width: 'fit-content',
                            maxWidth: '100%',
                            boxShadow: '0px 0.3px 1px #C0C0C0',
                            borderRadius: DefaultSetting.borderRadius,
                            overflow: 'hidden',
                            ...hoverEffect,
                            ...itemObj.sx,
                        }}
                    >
                        <CardActionArea
                            onClick={handleClick}
                            sx={{
                                width: 'fit-content',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box
                                component="img"
                                src={itemObj.src}
                                alt={itemObj.alt || '比賽花絮照片'}
                                referrerPolicy="no-referrer"
                                sx={{
                                    height: { xs: 'auto', sm: formattedHeight },
                                    maxHeight: { xs: '75vh', sm: formattedHeight },
                                    width: { xs: '100%', sm: 'auto' },
                                    maxWidth: '100%',
                                    display: 'block',
                                    objectFit: 'contain',
                                    ...itemObj.imgSx,
                                }}
                            />
                            {itemObj.caption && (
                                <CardContent sx={{ p: 1, width: '100%' }}>
                                    {typeof itemObj.caption === 'string' ? (
                                        <Typography align="center" variant="body2" sx={{ textTransform: 'none' }}>
                                            {itemObj.caption}
                                        </Typography>
                                    ) : (
                                        itemObj.caption
                                    )}
                                </CardContent>
                            )}
                        </CardActionArea>
                    </Card>
                );
            })}
        </Box>
    );
}
